import React, { useEffect, useState } from "react";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import api from "../../api";
import SubsPDF from "./adminComp/subsConsentPDF";
import "./SubsConsents.css";

// Lucide Icons
import {
  Search,
  RotateCcw,
  User,
  Mail,
  FileText,
  Globe,
  Calendar,
  Filter,
  ChevronRight,
  ChevronLeft,
  Signature,
  Download,
} from "lucide-react";
import { useAlert } from "react-alert";

function SubscriptionConsent({ adminType }) {
  const alert = useAlert();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(adminType !== "sackAdmin755");
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const getUsers = async () => {
    try {
      let payload = {
        page: page,
      };
      setLoader(true);
      const userData = await api.getConsentsSubs(payload);
      setData(userData.consents);
      setnoOfUser(userData.count);
      setLimit(userData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = {
        email: searchMail,
      };
      const res = await api.searchConsentsSubs(payload);
      if (res?.success) {
        setData(res?.consent);
      } else {
        alert.info("Email address not found");
      }
    } else {
      alert.info("Please insert email for search");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  useEffect(() => {
    if (adminType !== "sackAdmin755") {
      getUsers();
    }
  }, [page, resetPage]);

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
    setSearchMail("");
  };

  return (
    <>
      <div className="subscription-consent-container">
        {/* Header matching the design */}
        <div className="subscription-header-section">
          <div className="subscription-header-content">
            <div className="subscription-header-title-wrapper">
              <h1 className="header-title">Subscription Consents</h1>
              <span className="user-count-badge">{noOfUser}</span>
            </div>
            <p className="header-subtitle">
              Track and manage subscription consents and agreements
            </p>
          </div>

          <div className="search-section">
            <div className="search-box">
              <input
                type="text"
                placeholder="Search by email..."
                value={searchMail}
                onChange={(e) => setSearchMail(e.target.value)}
                onKeyPress={handleKeyPress}
                className="subscription-search-input"
              />
              <button
                className="subscription-search-btn"
                onClick={handleSearch}
              >
                Search
              </button>
            </div>
          </div>
        </div>

        <div className="content-card">
          <div className="table-header">
            <div className="table-info">
              <Filter size={18} />
              <span>
                SHOWING {data.length} OF {noOfUser} RECORDS
              </span>
            </div>
          </div>

          <Table
            data={data}
            page={page}
            setPage={setPage}
            noOfUser={noOfUser}
            limit={limit}
            adminType={adminType}
          />
        </div>
      </div>

      {loader && <Loader />}
    </>
  );
}

const Table = ({ data, page, setPage, noOfUser, limit, adminType }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="subscription-table-container">
        <div className="table-wrapper">
          <table className="subscription-table">
            <thead>
              <tr>
                <th>
                  <div className="table-header-cell">
                    <User size={16} />
                    <span>NAME</span>
                  </div>
                </th>
                <th>
                  <div className="table-header-cell">
                    <Mail size={16} />
                    <span>EMAIL</span>
                  </div>
                </th>
                <th>
                  <div className="table-header-cell">
                    <FileText size={16} />
                    <span>TERMS & CONDITIONS</span>
                  </div>
                </th>
                <th>
                  <div className="table-header-cell">
                    <Globe size={16} />
                    <span>IP ADDRESS</span>
                  </div>
                </th>
                <th>
                  <div className="table-header-cell">
                    <Signature size={16} />
                    <span>GODZILLA SIGNATURE</span>
                  </div>
                </th>
                <th>
                  <div className="table-header-cell">
                    <Calendar size={16} />
                    <span>TIMESTAMP</span>
                  </div>
                </th>
                <th>
                  <div className="table-header-cell">
                    <span>ACTION</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, key) => (
                  <tr key={key} className="subscription-row">
                    <td>
                      <div className="data-cell name-cell">
                        <div className="user-avatar">
                          {item?.user?.name?.charAt(0) || "U"}
                        </div>
                        <span className="data-value">
                          {item?.user?.name || "-"}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="data-cell">
                        <span className="data-value email-value">
                          {item?.user?.email || "-"}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="data-cell">
                        <span
                          className={`status-badge ${
                            item?.termsAccepted
                              ? "status-accepted"
                              : "status-pending"
                          }`}
                        >
                          {item?.termsAccepted ? "ACCEPTED" : "NOT ACCEPTED"}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="data-cell">
                        <span className="data-value ip-value">
                          {item?.ipAddress || "-"}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="data-cell">
                        <span className="data-value signature-value">
                          {item?.godzillaSign || "-"}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="data-cell">
                        <span className="data-value timestamp">
                          {formatDate(item?.createdAt)}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="action-cell">
                        <SubsPDF
                          name={item?.user?.name}
                          email={item?.user?.email}
                          termsAccepted={item?.termsAccepted}
                          ipAddress={item?.ipAddress}
                          timestamp={formatDate(item?.createdAt)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="empty-row">
                  <td colSpan="7">
                    <div className="empty-state">
                      <div className="empty-icon">
                        <FileText size={48} />
                      </div>
                      <h3>No Subscription Consents Found</h3>
                      <p>
                        {adminType === "sackAdmin755"
                          ? "Search by email to view a user's subscription consent"
                          : "No subscription consents are available at the moment"}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {data.length > 0 && (
          <div className="table-footer">
            <div className="pagination-info">
              Showing page {page} of {Math.ceil(noOfUser / limit)}
            </div>
            <div className="pagination-controls">
              <button
                className="pagination-button prev-button"
                onClick={() => setPage(page - 1)}
                disabled={page <= 1}
              >
                <ChevronLeft size={18} />
                Previous
              </button>

              <Stack spacing={2}>
                <Pagination
                  count={Math.ceil(noOfUser / limit)}
                  page={page}
                  onChange={handleChange}
                  shape="rounded"
                  color="primary"
                  size="medium"
                />
              </Stack>

              <button
                className="pagination-button next-button"
                onClick={() => setPage(page + 1)}
                disabled={page >= Math.ceil(noOfUser / limit)}
              >
                Next
                <ChevronRight size={18} />
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SubscriptionConsent;
